import React, { useState } from 'react';

import { TextField, Tooltip } from '@mui/material';

import { IQuestionnaireFormWidgetProps } from 'src/features/questionnaire/domain/types';

const TextFieldWidget: React.FC<IQuestionnaireFormWidgetProps> = ({
	question,
	onValueChange,
	isDisabled,
	error,
	helperText = 'This field is invalid',
}) => {
	const value = question.submitted_data?.value_text ?? '';

	const [textFieldValue, setTextFieldValue] = useState(value);

	const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setTextFieldValue(value);
		onValueChange(question, value, 'value_text');
	};

	const getToolTipTitle = () => {
		return (
			<span style={{ whiteSpace: 'pre-line' }}>
				Q: {question.text}
				{textFieldValue ? `\n\nAns: ${textFieldValue}` : ''}
			</span>
		);
	};

	return (
		<Tooltip title={getToolTipTitle()} arrow placement='left-start'>
			<TextField
				fullWidth
				label={question.text}
				value={textFieldValue}
				onChange={handleValueChange}
				disabled={isDisabled}
				error={error}
				helperText={error ? helperText : ''}
				required={question.is_required}
				sx={{
					'& input': {
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
					},
				}}
			/>
		</Tooltip>
	);
};

export default TextFieldWidget;
